(function() {
    'use strict';

    angular
        .module('app.reportes')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/reportes-contratos',
                config: {
                    templateUrl: 'app/reportes/contratos.html',
                    controller: 'reportes.Contratos',
                    controllerAs: 'vm',
                    title: 'Contratos'
                }
            },
            {
                url: '/reportes-ordenes',
                config: {
                    templateUrl: 'app/reportes/ordenes.html',
                    controller: 'reportes.Ordenes',
                    controllerAs: 'vm',
                    title: 'Ordenes'
                }
            }
        ];
    }
})();
